<div class="self-check-container">
  <div class="header">
    <h1>自主檢查表單管理</h1>
    <button class="btn-primary" (click)="openFormDialog()">
      <i class="fas fa-plus"></i> 新增表單
    </button>
  </div>

  <div class="forms-list">
    <div class="form-filters">
      <div class="search-box">
        <input type="text" [(ngModel)]="searchText" placeholder="搜尋表單...">
        <i class="fas fa-search search-icon"></i>
      </div>
    </div>

    <table class="forms-table">
      <thead>
        <tr>
          <th>表單名稱</th>
          <th>表單編號</th>
          <th>檢查週期</th>
          <th>檢查類別</th>
          <th>法規名稱(條文)</th>
          <th>適用部門</th>
          <th>主要欄位</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let form of selfCheckForms | filter:searchText">
          <td>{{ form.name }}</td>
          <td>{{ form.formNumber }}</td>
          <td>
            <span class="period-badge" [class]="form.checkPeriod">
              {{ getCheckPeriodText(form.checkPeriod) }}
            </span>
          </td>
          <td>
            <span class="tag" *ngFor="let type of form.types">{{ type }}</span>
          </td>
          <td>{{ form.regulation }}</td>
          <td>
            <span class="tag" *ngFor="let dept of form.departments">{{ dept }}</span>
          </td>
          <td>{{ form.keyField }}</td>
          <td class="actions">
            <button class="btn-icon" (click)="openFormDialog(form)" title="編輯">
              <i class="fas fa-edit"></i>
            </button>
            <button class="btn-icon" (click)="generateQrCode(form)" title="產生QR碼">
              <i class="fas fa-qrcode"></i>
            </button>
            <button class="btn-icon" (click)="viewRecords(form)" title="檢視紀錄">
              <i class="fas fa-chart-bar"></i>
            </button>
            <button class="btn-icon delete" (click)="deleteForm(form.id)" title="刪除">
              <i class="fas fa-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- 表單編輯對話框 -->
  <div class="modal" *ngIf="showFormDialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2>{{ selectedForm?.id ? '編輯表單' : '新增表單' }}</h2>
        <button class="close-btn" (click)="closeFormDialog()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label>表單名稱</label>
          <input type="text" [(ngModel)]="selectedForm!.name" placeholder="輸入表單名稱">
        </div>

        <div class="form-group">
          <label>表單編號</label>
          <input type="text" [(ngModel)]="selectedForm!.formNumber" placeholder="例如：OSH-03-01-02">
        </div>

        <div class="form-group">
          <label>表單類型</label>
          <div class="tags-container">
            <span class="tag" *ngFor="let type of selectedForm!.types">
              {{ type }} <button class="remove-tag" (click)="removeTag('types', type)">
                <i class="fas fa-times"></i>
              </button>
            </span>
          </div>
          <div class="tag-input">
            <input type="text" [(ngModel)]="currentTag" placeholder="輸入類型標籤">
            <button class="btn-small" (click)="addTag('types')">新增</button>
          </div>
          <div class="predefined-tags">
            <span class="tag-suggestion" *ngFor="let type of availableTypes"
                  (click)="currentTag = type; addTag('types')">{{ type }}</span>
          </div>
        </div>

        <div class="form-group">
          <label>適用部門</label>
          <div class="tags-container">
            <span class="tag" *ngFor="let dept of selectedForm!.departments">
              {{ dept }} <button class="remove-tag" (click)="removeTag('departments', dept)">
                <i class="fas fa-times"></i>
              </button>
            </span>
          </div>
          <div class="tag-input">
            <input type="text" [(ngModel)]="currentTag" placeholder="輸入部門標籤">
            <button class="btn-small" (click)="addTag('departments')">新增</button>
          </div>
          <div class="predefined-tags">
            <span class="tag-suggestion" *ngFor="let dept of availableDepartments"
                  (click)="currentTag = dept; addTag('departments')">{{ dept }}</span>
          </div>
        </div>

        <div class="form-group">
          <label>檢查週期</label>
          <select [(ngModel)]="selectedForm!.checkPeriod">
            <option *ngFor="let period of checkPeriods" [value]="period.value">
              {{ period.text }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>主要欄位 (用於紀錄檢視)</label>
          <input type="text" [(ngModel)]="selectedForm!.keyField" placeholder="例如：車輛編號、設備ID">
        </div>

        <div class="form-group">
          <label>法規名稱(條文)</label>
          <input type="text" [(ngModel)]="selectedForm!.regulation" placeholder="例如：安衛辦法(50)">
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn-secondary" (click)="closeFormDialog()">取消</button>
        <button class="btn-primary" (click)="saveForm()">儲存</button>
      </div>
    </div>
  </div>

  <!-- 紀錄檢視對話框 -->
  <div class="modal record-modal" *ngIf="showRecordDialog && selectedForm">
    <div class="modal-content wide">
      <div class="modal-header">
        <h2>{{ selectedForm.name }} - 檢查紀錄</h2>
        <button class="close-btn" (click)="closeRecordDialog()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-info">
          <div class="info-item">
            <label>表單編號:</label>
            <span>{{ selectedForm.formNumber }}</span>
          </div>
          <div class="info-item">
            <label>檢查週期:</label>
            <span>{{ getCheckPeriodText(selectedForm.checkPeriod) }}</span>
          </div>
          <div class="info-item">
            <label>法規名稱:</label>
            <span>{{ selectedForm.regulation }}</span>
          </div>
        </div>

        <div class="record-chart">
          <div class="chart-header" *ngIf="recordTableData.length > 0">
            <h3>
              {{ selectedForm.checkPeriod === 'beforeOperation' ? '作業前檢點紀錄' :
                 selectedForm.checkPeriod === 'daily' ? '日期（每日）' :
                 selectedForm.checkPeriod === 'weekly' ? '週次（每週）' :
                 selectedForm.checkPeriod === 'monthly' ? '月份（每月）' :
                 selectedForm.checkPeriod === 'quarterly' ? '季度（每季）' : '年度（每年）' }}
            </h3>
          </div>

          <div class="chart-body">
            <div *ngIf="recordTableData.length === 0" class="placeholder-chart">
              <p>目前沒有 {{ selectedForm.name }} 的檢查紀錄資料</p>
              <button class="btn-primary">
                <i class="fas fa-plus"></i> 新增檢查紀錄
              </button>
            </div>

            <table *ngIf="recordTableData.length > 0" class="record-table">
              <thead>
                <tr>
                  <th *ngFor="let header of recordTableHeaders">{{ header }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of recordTableData">
                  <td>{{ row.keyValue }}</td>
                  <td *ngFor="let header of recordTableHeaders.slice(1)" [class]="getStatusClass(row[header])">
                    <span *ngIf="row[header] === 'passed'">
                      <i class="fas fa-check text-success"></i>
                    </span>
                    <span *ngIf="row[header] === 'failed'">
                      <i class="fas fa-times text-danger"></i>
                    </span>
                    <span *ngIf="row[header] === 'pending'">
                      <i class="fas fa-plus text-info"></i>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn-secondary" (click)="closeRecordDialog()">關閉</button>
        <button class="btn-primary">
          <i class="fas fa-file-export"></i> 匯出報表
        </button>
      </div>
    </div>
  </div>
</div>
